import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import browse from './modules/browse';
import recipe from './modules/recipe';
import restaurant from './modules/restaurant';
import shoppingList from './modules/shoppingList';

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,

  modules: {
    browse,
    recipe,
    restaurant,
    shoppingList,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js